import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { DepartamentoResponse } from "../../response/comun/DepartamentoResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Departamentos (gRPC-Web `CatalogosPlataformaService.ListDepartamentos`). Lista cacheada en memoria toda la sesión (catálogo de solo lectura); dos
 *  llamadas simultáneas comparten el mismo request. */
export class DepartamentoListService {
  static readonly instance = new DepartamentoListService();
  private constructor() {}

  private _cache: DepartamentoResponse[] | null = null;
  private _inflight: Promise<DepartamentoResponse[]> | null = null;

  /** Lista completa (el servidor ya la manda sin eliminados y ordenada). */
  async get(): Promise<DepartamentoResponse[]> {
    if (this._cache) return this._cache;
    if (this._inflight) return this._inflight;
    this._inflight = grpcCall(() => grpcClient(CatalogosPlataformaService).listDepartamentos({}))
      .then((response) => {
        this._cache = response.items.map((d) => ({ id: d.id, nombre: d.nombre, isEliminado: false }));
        return this._cache;
      })
      .finally(() => {
        this._inflight = null;
      });
    return this._inflight;
  }
}
